import { render, staticRenderFns } from "./TonnageSummary.vue?vue&type=template&id=62d623cc&scoped=true&"
import script from "./TonnageSummary.vue?vue&type=script&lang=js&"
export * from "./TonnageSummary.vue?vue&type=script&lang=js&"
import style0 from "./TonnageSummary.vue?vue&type=style&index=0&id=62d623cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d623cc",
  null
  
)

export default component.exports